import { Component, Prop, Vue } from "vue-property-decorator";
import { store } from "@/main";
import * as types from "@/store/constants/ins_user_info_types";
@Component
class BindVipConfirmContent extends Vue {
  @Prop()
  private ctx: any;
  private user_name: any =
    store.getters[types.GETTER_CURRENT_INS_USER_INFO].ins_user_info.user_name;

  private spanStyle =
    "font-size: 16px;line-height: 22px;color: rgb(79,121,255);";
  private divStyle =
    "font-size: 16px;line-height: 22px;  color: rgb(140,140,140);padding-bottom:20px;";

  public render() {
    return (
      <div style={this.divStyle}>
        Now confirm @<span style={this.spanStyle}>{this.user_name}</span> to get
        10 bonus followers every day.
      </div>
    );
  }
}

export default BindVipConfirmContent;
